/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'

export default function TeacherHeadSubItem(props) {
    return (
        <li className={`list-item ${props.active ? "active" : ""}`}>
            <img src={process.env.PUBLIC_URL + "/assets/images/mn_tea_sub_" + props.index + ".avif"} alt=''/>
        </li>
    )
}
